import { render, staticRenderFns } from "./v-flags.vue?vue&type=template&id=1057e84e&"
import script from "./v-flags.vue?vue&type=script&lang=js&"
export * from "./v-flags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports